import { render } from "./SearchAirtime.vue?vue&type=template&id=601fa3fe&scoped=true"
import script from "./SearchAirtime.vue?vue&type=script&lang=js"
export * from "./SearchAirtime.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=601fa3fe&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601fa3fe"]])

export default __exports__